
import apiClient from "../utils/axiosInterceptor"; 

export const getNegotiationContractsAPI = async () => {
    try {
        const response = await apiClient.get(`/fapp-core-api/api/Negotiation/All`);
        return response;
    } catch (error: any) {
        console.error('Error fetching:', error);
        return error.response?.status || 500;
    }
}

export const getNegotiationContractDataAPI = async (payload: any) => {
    try {
        const response = await apiClient.get(`/fapp-core-api/api/Negotiation/${payload}`);
        return response;
    } catch (error: any) {
        console.error('Error fetching:', error);
        return error.response?.status || 500;
    }
}
export const saveDocumentOutcome = async (data: any) => {
    const payload = data.payload || {};
    const getValue = (key: string, fallback: any) => payload[key] ?? fallback;
    const finalData = {
        ID: getValue("id", ""),
        TargetOutcome: getValue("TargetOutcome", 0),
        DiscountTerms: getValue("DiscountTerms", ""),
        PaymentTermsOutcome: getValue("PaymentTermsOutcome", ""),
        IncoTermsOutcome: getValue("IncoTermsOutcome", ""),
        LocalStockOutcome: getValue("LocalStockOutcome", ""),
        PaymentTermsTargetAchieved: getValue("PaymentTermsTargetAchieved", ""),
        IncoTermsTargetAchieved: getValue("IncoTermsTargetAchieved", ""),
        LocalStockTargetAchieved: getValue("LocalStockTargetAchieved", ""),
        AchievedTarget: getValue("AchievedTarget", 0),
        TotalNegotiationRounds: getValue("TotalNegotiationRounds", 0),
        EndedWithArgument: Boolean(payload.EndedWithArgument),
        OverallSuccessRate: getValue("OverallSuccessRate", 0),
        OverallNegotiationComment: getValue("OverallNegotiationComment", ""),
        NextNegotiationSupplierNotes: getValue("NextNegotiationSupplierNotes", ""),
        NextNegotiationSalesrepNotes: getValue("NextNegotiationSalesrepNotes", ""),
        LeadSalesrepReminder: getValue("LeadSalesrepReminder", ""),
        ConfirmPreviousStrategyType: getValue("ConfirmPreviousStrategyType", ""),
        SelectedStrategyType: getValue("SelectedStrategyType", ""),
        Status: getValue("Status", ""),
        NegotiationRoundsDetails: getValue("NegotiationRoundsDetails", []),
    }
    try {
        const response = apiClient.post(`/fapp-core-api/api/DocumentOutcome`, finalData);
        return response;
    } catch (error: any) {
        console.error("Error deleting negotiation action", error);
    }
}

export const saveDetailedNegotiationDataAPI = async (payload: any) => {

    try {

        const response = await apiClient.post(`/fapp-core-api/api/DetailedNegotiationOverview`, payload);
        return response;
    } catch (error: any) {
        console.error('Error fetching:', error);
        return error.response?.status || 500;
    }
}

export const getReviewNegotiationData = async () => {
    try {
        const response = await apiClient.get(`/fapp-core-api/api/Negotiation/All`);
        return response;
    } catch (error: any) {
        console.error('Error fetching:', error);
        return error.response?.status || 500;
    }
}
export const saveReviewNegotiation = async (payload: any) => {
    console.log("payload", payload);
    try {
        const response = await apiClient.post(`/`, payload);
        return response;
    } catch (error: any) {
        console.error('Error fetching:', error);
        return error.response?.status || 500;
    }
}